import { render, staticRenderFns } from "./HRMAddNewNotesModal.vue?vue&type=template&id=bd84653e&"
import script from "./HRMAddNewNotesModal.vue?vue&type=script&lang=js&"
export * from "./HRMAddNewNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports